<template>
    <v-card ref="queryTable">
        <v-card-title><v-icon :color="toolbarColor">mdi-database</v-icon> Data</v-card-title>
        <v-data-table :headers="headers" :items="rows" :items-per-page="20"></v-data-table>
    </v-card>
</template>

<script>
export default {
    name: 'reports-data',
    props: {
        headers: {
            required: true,
            type: Array
        },
        rows: {
            required: true,
            type: Array
        }
    },
    methods: {
        setTableLoader(bool) {
            this.$refs.queryTable.loading = bool;
        }
    },
    computed: {
        toolbarColor() {
            return '#8950FC';
        }
    }
}
</script>